module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "comments"
  }, [_c('md-field', {
    staticClass: "comment-field"
  }, [_c('label', [_vm._v("Комментарий")]), _c('md-textarea', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: ('required'),
      expression: "'required'"
    }],
    staticClass: "edit-comment",
    attrs: {
      "disabled": _vm.sending,
      "name": "new_comment"
    },
    on: {
      "focus": function($event) {
        _vm.showCommentButton = true
      },
      "blur": _vm.hideCommentButton
    },
    model: {
      value: (_vm.comment.text),
      callback: function($$v) {
        _vm.$set(_vm.comment, "text", $$v)
      },
      expression: "comment.text"
    }
  })], 1), _c('div', {
    staticClass: "md-layout md-alignment-top-right"
  }, [_c('md-button', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showCommentButton),
      expression: "showCommentButton"
    }],
    staticClass: "md-primary md-raised md-dense",
    on: {
      "click": function($event) {
        _vm.saveComment(_vm.comment)
      }
    }
  }, [_vm._v("Отправить")])], 1), (Object.keys(_vm.comments).length) ? _c('div', {
    staticClass: "items"
  }, _vm._l((_vm.comments), function(comment) {
    return _c('div', {
      key: comment.id,
      staticClass: "comment"
    }, [(_vm.$store.state.users.current.id == comment.user_id) ? [_c('div', {
      staticClass: "md-layout"
    }, [_c('div', [_c('div', {
      staticClass: "user"
    }, [_vm._v(_vm._s(comment.user.login))]), _c('div', {
      staticClass: "date"
    }, [_vm._v(_vm._s(comment.created_at))])]), _c('div', {
      staticClass: "md-layout-item md-layout md-alignment-top-right actions"
    }, [_c('md-button', {
      staticClass: "small md-dense md-icon-button edit",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          comment.edit = 1;
          comment.oldText = comment.text;
        }
      }
    }, [_c('md-icon', [_vm._v("edit")])], 1), _c('md-button', {
      staticClass: "small md-dense md-icon-button edit",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          $event.preventDefault();
          _vm.deleteComment(comment.id)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1)]), _c('div', {
      staticClass: "text"
    }, [_vm._v(_vm._s(comment.text))])] : _vm._e(), _c('md-field', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (comment.edit === 1),
        expression: "comment.edit === 1"
      }],
      class: {
        'md-invalid': _vm.errors.has('edit_comment')
      }
    }, [_c('label', [_vm._v("Комментарий")]), _c('md-textarea', {
      attrs: {
        "id": "edit-comment",
        "disabled": _vm.sending,
        "name": "edit_comment"
      },
      model: {
        value: (comment.text),
        callback: function($$v) {
          _vm.$set(comment, "text", $$v)
        },
        expression: "comment.text"
      }
    }), _c('md-button', {
      staticClass: "md-dense md-icon-button",
      on: {
        "click": function($event) {
          _vm.saveComment(comment)
        }
      }
    }, [_c('md-icon', [_vm._v("done")])], 1), _c('md-button', {
      staticClass: "md-dense md-icon-button md-warn",
      on: {
        "click": function($event) {
          comment.edit = 0;
          comment.text = comment.oldText;
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1)], 2)
  })) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1bbda416","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/comments.vue
// module id = 1055
// module chunks = 0